import * as creditsPanelActions from './actions'
import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

export const creditsPanelRequest = () => (dispatch, getState) => {
  const { auth } = getState()
  const {
    userData: { username },
    planSelected: { partner_plan_code: planCode },
  } = auth

  dispatch(creditsPanelActions.cleanCredits())

  axios.get(apiEndpoints.PERSON_VALIDITIES(username, planCode))
    .then(response => dispatch(creditsPanelActions.loadCreditsSuccess(response.data, response.messages)))
    .catch(error => dispatch(creditsPanelActions.loadCreditsFailure(error.response?.data)))
}

export const creditsPanelCreateMedicalRequest = (planCode, updateCredits) => dispatch => {
  const payload = {
    ...(planCode && { plan_code: planCode }),
  }

  dispatch(creditsPanelActions.requestCredits())

  axios.post(apiEndpoints.VALIDITIES, payload)
    .then(res => {
      dispatch(creditsPanelActions.requestCreditsSuccess(res.data))
      if (updateCredits) {
        dispatch(creditsPanelRequest())
      }
    })
    .catch(err => dispatch(creditsPanelActions.requestCreditsFailure(err.response.data)))
}
